import { Component } from '@angular/core';

@Component({
    selector: 'app-generic',
    templateUrl: './generic.component.html',
    styleUrls: ['./generic.component.css'],
    standalone: false
})
export class GenericErrorComponent {

}
